import { render } from "./ListOrganizationSelf.vue?vue&type=template&id=152879ec&scoped=true"
import script from "./ListOrganizationSelf.vue?vue&type=script&lang=js"
export * from "./ListOrganizationSelf.vue?vue&type=script&lang=js"

import "./ListOrganizationSelf.vue?vue&type=style&index=0&id=152879ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-152879ec"]])

export default __exports__